import { createTheme } from "@mui/material";

export const ThemeRed = createTheme({
    palette: {
      primary: {
        main: '#A53B29',
      },
      secondary: {
        main: '#7C554D',
      },
      tertiary: {
        main: '#725C22',
      },
      error: {
        main: '#BA1A1A',
      },
      background: {
        main: '#201A19',
      },
      outline: {
        main: '#A08C89',
      },
    },
});